// HR taxonomies — real values, no fake statistics.

export const INDUSTRIES = [
  "Technology", "Software & SaaS", "Financial Services", "Banking", "Insurance",
  "Healthcare", "Pharmaceuticals", "Biotechnology", "Manufacturing", "Automotive",
  "Retail", "E-commerce", "Consumer Goods", "Food & Beverage", "Hospitality",
  "Travel & Tourism", "Media & Entertainment", "Gaming", "Telecommunications",
  "Energy & Utilities", "Oil & Gas", "Renewable Energy", "Construction", "Real Estate",
  "Logistics & Supply Chain", "Transportation", "Aerospace & Defense", "Education",
  "Non-Profit", "Government", "Legal Services", "Consulting", "Marketing & Advertising",
  "Agriculture", "Chemicals", "Mining", "Public Sector",
];

export const COMPANY_SIZES = ["Startup", "Small Business", "Mid-size", "Enterprise"];

export const DEPARTMENTS = [
  "Human Resources", "Talent Acquisition", "Learning & Development", "Compensation & Benefits",
  "People Analytics", "Talent Management", "Employer Branding", "Diversity & Inclusion",
  "Payroll", "Employee Relations", "Performance Management", "Workforce Planning",
  "Finance", "Accounting", "Financial Planning & Analysis", "Internal Audit",
  "Marketing", "Product Marketing", "Growth Marketing", "Communications", "Public Relations",
  "Sales", "Business Development", "Customer Success", "Customer Support",
  "Operations", "Supply Chain", "Procurement", "Facilities", "Administration",
  "Information Technology", "Software Engineering", "Data Analytics", "Data Science",
  "Machine Learning", "Cybersecurity", "Information Security", "DevOps & Platform",
  "Product Management", "Project Management", "Program Management",
  "Legal", "Compliance", "Risk", "Corporate Strategy",
  "Research & Development", "Quality Assurance", "Manufacturing",
];

// Job title library keyed to department (falls back to ALL if not listed)
export const JOB_TITLES = [
  // HR
  "HR Executive", "HR Generalist", "HR Manager", "HR Business Partner", "HR Director",
  "Chief People Officer", "Talent Acquisition Specialist", "Recruiter", "Senior Recruiter",
  "Talent Acquisition Manager", "HR Operations Manager", "People Analytics Manager",
  "Learning & Development Manager", "L&D Specialist", "Compensation Analyst",
  "Total Rewards Manager", "Employee Relations Manager", "DEI Program Manager",
  "Employer Brand Manager", "HRIS Analyst", "Payroll Specialist", "Payroll Manager",
  "Organizational Development Consultant", "Workforce Planning Analyst",
  // Technology
  "Software Engineer", "Senior Software Engineer", "Staff Software Engineer",
  "Principal Engineer", "Frontend Developer", "Backend Developer", "Full Stack Developer",
  "Mobile Engineer", "iOS Engineer", "Android Engineer", "DevOps Engineer",
  "Site Reliability Engineer", "Platform Engineer", "Cloud Architect", "Solutions Architect",
  "Data Engineer", "Analytics Engineer", "Data Analyst", "Data Scientist",
  "Machine Learning Engineer", "AI Research Scientist", "Security Engineer",
  "Application Security Engineer", "Product Manager", "Senior Product Manager",
  "Group Product Manager", "Director of Product", "Engineering Manager",
  "Director of Engineering", "VP of Engineering", "CTO",
  // Finance / Legal
  "Financial Analyst", "Senior Financial Analyst", "Finance Manager", "Controller",
  "Director of Finance", "CFO", "Accountant", "Senior Accountant", "Audit Manager",
  "Compliance Officer", "Risk Analyst", "Legal Counsel", "Senior Legal Counsel",
  // Sales / Marketing
  "Sales Development Representative", "Account Executive", "Senior Account Executive",
  "Account Manager", "Customer Success Manager", "Head of Sales", "VP of Sales",
  "Marketing Manager", "Product Marketing Manager", "Content Marketing Manager",
  "Growth Marketing Manager", "SEO Specialist", "Brand Manager", "Head of Marketing",
  // Operations
  "Operations Analyst", "Operations Manager", "Supply Chain Manager",
  "Procurement Specialist", "Program Manager", "Project Manager", "Chief of Staff",
  "Business Analyst", "Strategy Manager",
  // Design
  "Product Designer", "UX Designer", "UX Researcher", "Design Lead", "Head of Design",
];

export const SENIORITIES = [
  "Entry Level", "Associate", "Mid Level", "Senior", "Lead", "Manager", "Director", "VP", "Executive",
];

export const EXPERIENCE_RANGES = ["0-1 years", "1-3 years", "3-5 years", "5-8 years", "8-12 years", "12+ years"];

export const EMPLOYMENT_TYPES = ["Full-time", "Part-time", "Contract", "Temporary", "Internship", "Freelance"];

export const WORK_ARRANGEMENTS = ["On-site", "Hybrid", "Remote"];

export const PRIORITIES = ["Low", "Medium", "High", "Critical"];

export const TIMELINES = ["Immediate", "Within 30 Days", "Within 60 Days", "Future Hiring"];

export const CURRENCIES = ["USD", "EUR", "GBP", "INR", "AUD", "CAD", "SGD", "AED", "JPY"];

export const JD_STYLES = ["Professional", "Corporate", "Startup", "Executive", "Friendly", "Technical"];
export const JD_LENGTHS = ["Short", "Standard", "Detailed"];
export const JD_SECTIONS = ["Company Overview", "Responsibilities", "KPIs", "Benefits", "Career Growth", "Diversity Statement"];

export const INTERVIEW_TYPES = ["HR", "Technical", "Behavioral", "Managerial", "Case Study", "Situational", "Culture & Values"];

export const CANDIDATE_STAGES = [
  { key: "applied", label: "Applied" },
  { key: "screening", label: "Screening" },
  { key: "shortlisted", label: "Shortlisted" },
  { key: "interview", label: "Interview" },
  { key: "assessment", label: "Assessment" },
  { key: "offer", label: "Offer" },
  { key: "hired", label: "Hired" },
  { key: "rejected", label: "Rejected" },
  { key: "withdrawn", label: "Withdrawn" },
];

export const JOB_STATUSES = [
  { key: "draft", label: "Draft" }, { key: "open", label: "Open" },
  { key: "on_hold", label: "On Hold" }, { key: "closed", label: "Closed" },
  { key: "cancelled", label: "Cancelled" },
];

export const ROLES = [
  { key: "org_admin", label: "Organization Admin" },
  { key: "hr_manager", label: "HR Manager" },
  { key: "recruiter", label: "Recruiter" },
  { key: "hiring_manager", label: "Hiring Manager" },
  { key: "viewer", label: "Viewer" },
];

export const RECOMMENDATIONS = ["Strong Hire", "Hire", "Lean Hire", "Lean No Hire", "No Hire"];

// 100+ skills across categories
export const SKILL_CATEGORIES = {
  "Technical": ["Python", "JavaScript", "TypeScript", "Java", "Go", "Rust", "C++", "C#", "Ruby", "PHP",
    "React", "Vue", "Angular", "Next.js", "Node.js", "Django", "FastAPI", "Spring Boot",
    "PostgreSQL", "MySQL", "MongoDB", "Redis", "Elasticsearch", "Snowflake",
    "AWS", "GCP", "Azure", "Docker", "Kubernetes", "Terraform", "CI/CD"],
  "Data": ["SQL", "Advanced Excel", "Power BI", "Tableau", "Looker", "Airflow", "dbt", "Spark", "Kafka",
    "Machine Learning", "Deep Learning", "NLP", "Statistics", "A/B Testing"],
  "Product": ["Product Strategy", "Roadmapping", "User Research", "Product Analytics", "OKRs",
    "Wireframing", "Figma", "Product Discovery"],
  "HR": ["Recruitment", "Sourcing", "Interviewing", "Employer Branding", "ATS", "HRIS", "Onboarding",
    "Compensation & Benefits", "Performance Management", "Talent Development", "L&D",
    "Diversity & Inclusion", "Workforce Planning", "Employee Relations", "Payroll"],
  "Sales & Marketing": ["Salesforce", "HubSpot", "Cold Outreach", "Pipeline Management", "Forecasting",
    "SEO", "SEM", "Content Marketing", "Brand Strategy", "PPC", "Marketing Automation"],
  "Finance": ["Financial Modeling", "Budgeting", "Forecasting", "FP&A", "Accounting", "Auditing",
    "SAP", "NetSuite", "QuickBooks", "IFRS", "US GAAP"],
  "Operations": ["Project Management", "Program Management", "Agile", "Scrum", "Kanban",
    "Six Sigma", "Lean", "Supply Chain", "Procurement", "Vendor Management"],
  "Leadership": ["People Management", "Coaching", "Mentoring", "Strategic Thinking",
    "Decision Making", "Change Management", "Executive Presence"],
  "Soft Skills": ["Communication", "Stakeholder Management", "Collaboration", "Adaptability",
    "Problem Solving", "Analytical Thinking", "Time Management", "Ownership",
    "Cross-functional Leadership", "Presentation Skills", "Negotiation"],
};

export const ALL_SKILLS = Object.entries(SKILL_CATEGORIES).flatMap(([cat, arr]) =>
  arr.map((s) => ({ name: s, category: cat })),
);

export const CERTIFICATIONS = [
  "PMP", "Scrum Master (CSM)", "PMI-ACP", "Six Sigma Green Belt", "Six Sigma Black Belt",
  "AWS Solutions Architect", "AWS Developer", "GCP Professional", "Azure Solutions Architect",
  "CKA", "CISSP", "CISA", "CISM", "CFA", "CPA", "SHRM-CP", "SHRM-SCP", "PHR", "SPHR",
  "Google Analytics", "HubSpot Inbound", "Salesforce Admin", "ITIL v4", "TOGAF",
];

export const LANGUAGES = ["English", "Spanish", "French", "German", "Portuguese", "Italian",
  "Mandarin", "Japanese", "Korean", "Hindi", "Arabic", "Russian", "Dutch"];

export const BENEFITS = [
  "Health Insurance", "Dental", "Vision", "Paid Time Off", "Remote Work", "Flexible Hours",
  "Learning Budget", "Performance Bonus", "Stock Options", "Relocation Assistance",
  "Gym Membership", "Wellness Program", "Parental Leave", "Retirement Benefits",
  "Employee Assistance Program",
];
